import type { LanguageCode } from '@backoffice-frontend/graphql'
import { useGetServiceAreasQuery } from './serviceAreas.hook'
import { useGlobalRegion } from './UserSettings/useSelectedRegion'
import { regionToPrimaryServiceAreaId } from './useRegionToServiceAreaMapping'

export const useAreaDefaultLanguage = (): LanguageCode | undefined => {
  const [region] = useGlobalRegion()
  const serviceAreaId = region
    ? regionToPrimaryServiceAreaId[region.id]
    : undefined
  const { data } = useGetServiceAreasQuery({ skip: !serviceAreaId })

  return data?.serviceAreas.find(
    serviceArea => serviceArea.id === serviceAreaId,
  )?.defaultLanguage
}
